import { App as AppWrapper, ConfigProvider } from "antd";
import store from "./store";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import { Suspense, lazy } from "react";

import "./helpers/i18n.ts";
// //CSS
// import "./Assets/CSS/custom.css";
// import "./Assets/CSS/style.css";
// import "./Assets/CSS/component.css";

// // Auth CSS
// import "./Auth/CSS/style.css";

// // Component CSS
// import "./Assets/CSS/component.css";
// // View CSS
// import "./View/CSS/style.css";

// // Admin CSS
// import "./Admin/CSS/style.css";
// import "./Admin/CSS/admin.css";

import { ErrorFallbackPage } from "./helpers/ErrorFallbackPage";
import { SiteLoader } from "./Components/Components";
import ToastHandler from "./helpers/ToastHandler";
import { alias } from "./helpers/utils";
import { sideMenuBarData } from "./Assets/navigation";
import Home from "./Components/Pages/Home";

const Login = lazy(() => import("./Auth/Pages/Login"));
const Profile = lazy(() => import("./Admin/Pages/Profile"));
const Dashboard = lazy(() => import("./Admin/Pages/Dashboard"));

const ChangePassword = lazy(() => import("./Admin/Pages/ChangePassword"));
const ForgotPassword = lazy(() => import("./Auth/Pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./Auth/Pages/Resetpassword"));

const PageNotFound = lazy(() => import("./Components/Error"));
const AdminIndex = lazy(() => import("./Admin/AdminIndex"));

const StaticPages = lazy(() => import("./Admin/Pages/StaticPages"));
const EditStaticPage = lazy(() => import("./Admin/Pages/EditStaticPage"));
const DetailsStaticPage = lazy(() => import("./Admin/Pages/DetailsStaticPage"));
const EmailTemplate = lazy(() => import("./Admin/Pages/EmailTemplate"));
const EditEmailTemplate = lazy(() => import("./Admin/Pages/EditEmailTemplate"));
const User = lazy(() => import("./Admin/Pages/User"));
const Matches = lazy(() => import("./Admin/Pages/Matches"));
const Cruise = lazy(() => import("./Admin/Pages/Cruise"));
const Setting = lazy(() => import("./Admin/Pages/Setting"));

function App() {
	return (
		<ConfigProvider
			theme={{
				token: {
					fontFamily: "Nunito Sans Regular",
				},
			}}
		>
			<AppWrapper>
				<Provider store={store}>
					<BrowserRouter basename={alias}>
						<Suspense fallback={<SiteLoader />}>
							<ErrorBoundary FallbackComponent={ErrorFallbackPage}>
								<Routes>
									{/* Home */}
									<Route path="/" element={<Home />} />
									{/* Auth */}

									<Route path="/auth">
										<Route path="login" element={<Login />} />
										<Route path="forgot-password" element={<ForgotPassword />} />
										<Route path="*" element={<PageNotFound />} />
										<Route path="forgot-password/:token" element={<ResetPassword />} />
									</Route>
									{/* Auth */}

									{/* Admin */}
									<Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
									<Route path="/admin" element={<AdminIndex navigationData={sideMenuBarData} />}>
										<Route path="dashboard" element={<Dashboard />} />

										<Route path="profile" element={<Profile />} />
										<Route path="change-password" element={<ChangePassword />} />
										<Route path="*" element={<PageNotFound />} />
										<Route path="static-pages">
											<Route path="" element={<StaticPages />} />
											<Route path="edit-staticpage/:id" element={<EditStaticPage />} />
										</Route>
										<Route path="users">
											<Route path="" element={<User />} />
										</Route>
										<Route path="matches">
											<Route path="" element={<Matches />} />
										</Route>
										<Route path="cruise">
											<Route path="" element={<Cruise />} />
										</Route>
										<Route path="settings">
											<Route path="" element={<Setting />} />
										</Route>
										{/* email template */}
										<Route path="email-template">
											<Route path="" element={<EmailTemplate />} />
											<Route path="edit/:id" element={<EditEmailTemplate />} />
										</Route>
									</Route>
									{/* Admin */}
									{/* static page */}
									<Route path="static-pages">
										<Route path="details/:url" element={<DetailsStaticPage />} />
									</Route>
									{/* static page */}
									{/* Not found page */}
									<Route path="*" element={<PageNotFound />} />
								</Routes>
							</ErrorBoundary>
						</Suspense>
					</BrowserRouter>
					<ToastHandler />
				</Provider>
			</AppWrapper>
		</ConfigProvider>
	);
}

export default App;
